import { render, staticRenderFns } from "./Amazon.vue?vue&type=template&id=35e3e062&lang=pug"
import script from "./Amazon.vue?vue&type=script&lang=ts"
export * from "./Amazon.vue?vue&type=script&lang=ts"
import style0 from "./Amazon.vue?vue&type=style&index=0&id=35e3e062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports